import { inject, Injectable } from '@angular/core';
import { ELanguage, routesLang } from '../utils';
import { TranslationService } from './translation.service';

type TextForLangParams = Partial<Record<ELanguage, string>>;

@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  private translationService = inject(TranslationService);

  getTraslateUrlCompetitionDetails(
    allTextForLangs: Partial<Record<ELanguage, string>>,
    name: string,
    competitionId: string
  ): string {
    const lang = this.translationService.getCurrentLanguage() as ELanguage;

    return `${lang === ELanguage.EN ? '/en' : ''}/${routesLang({
      type: 'football',
      lang,
    })}/${routesLang({
      type: 'league',
      lang,
    })}/${this.translationService.normalizeRoute(
      this.translationService.getTraduccionName(allTextForLangs, name)
    )}/${competitionId}`;
  }
  getTraslateUrlTeamDetails(
    allTextForLangs: Partial<Record<ELanguage, string>>,
    name: string,
    teamId: string
  ): string {
    const lang = this.translationService.getCurrentLanguage() as ELanguage;

    return `${lang === ELanguage.EN ? '/en' : ''}/${routesLang({
      type: 'football',
      lang,
    })}/${routesLang({
      type: 'team',
      lang,
    })}/${this.translationService.normalizeRoute(
      this.translationService.getTraduccionName(allTextForLangs, name)
    )}/${teamId}`;
  }
}
